import classNames from 'classnames';

import { FormattedCurrency } from '../../lib/components/formattedCurrency/FormattedCurrency';

interface ProductPriceProps {
	price?: number;
	currency?: string;
	isSmallComponent?: boolean;
}

const ProductPrice = ({ price, currency, isSmallComponent }: ProductPriceProps) => {
	if (price == null || !currency) return null;

	return (
		<h3
			className={classNames(
				'tracking-wide font-normal mt-[1.5rem] mb-[0.5rem] uppercase',
				'text-lg sm:text-xl sm:font-medium',
				isSmallComponent === true ? 'text-base my-1' : 'my-4',
			)}
		>
			<FormattedCurrency price={price} currency={currency} />
		</h3>
	);
};

export default ProductPrice;
